import { CreditAnalysisStatus } from '@/api/commercial/credit-analysis';

export const CREDIT_ANALYSIS_STATUS_LABEL: Record<
  CreditAnalysisStatus,
  { label: string; color: string }
> = {
  [CreditAnalysisStatus.NOT_STARTED]: {
    label: 'Não iniciada',
    color: 'bg-gray-100 text-gray-800',
  },
  [CreditAnalysisStatus.PENDING_EXTERNAL_DOCS]: {
    label: 'Aguardando documentação',
    color: 'bg-yellow-100 text-yellow-800',
  },
  [CreditAnalysisStatus.PENDING_ANALYSIS]: {
    label: 'Aguardando Análise',
    color: 'bg-blue-100 text-blue-800',
  },
  [CreditAnalysisStatus.IN_ANALYSIS]: {
    label: 'Em análise',
    color: 'bg-indigo-100 text-indigo-800',
  },
  [CreditAnalysisStatus.APPROVED]: {
    label: 'Em dia',
    color: 'bg-green-100 text-green-800',
  },
  [CreditAnalysisStatus.PARTIALLY_APPROVED]: {
    label: 'Em dia',
    color: 'bg-green-100 text-green-800',
  },
  [CreditAnalysisStatus.DOC_DECLINED]: {
    label: 'Documentação recusada',
    color: 'bg-red-100 text-red-800',
  },
  [CreditAnalysisStatus.DECLINED]: {
    label: 'Reprovada',
    color: 'bg-red-100 text-red-800',
  },
  [CreditAnalysisStatus.EXPIRED]: {
    label: 'Vencida',
    color: 'bg-red-100 text-red-800',
  },
};

// Situation derived from status
export type CreditAnalysisSituation = 'APPROVED' | 'PARTIALLY_APPROVED' | 'DECLINED';

export const CREDIT_ANALYSIS_SITUATION_LABEL: Record<
  CreditAnalysisSituation | '-',
  { label: string; color: string }
> = {
  APPROVED: {
    label: 'Aprovada',
    color: 'bg-green-100 text-green-800',
  },
  PARTIALLY_APPROVED: {
    label: 'Aprovada com ressalva',
    color: 'bg-yellow-100 text-yellow-800',
  },
  DECLINED: {
    label: 'Reprovada',
    color: 'bg-red-100 text-red-800',
  },
  '-': {
    label: '-',
    color: 'bg-gray-100 text-gray-800',
  },
};
